<div class="mt-16 p-4 md:pt-8">
    <div class="text-white md:mx-auto md:max-w-screen-lg md:p-8">
        <h2 class="mb-4 text-4xl leading-snug md:text-5xl">
            If you love travel,<br />
            join our newsletter
        </h2>
        <p class="block">
            Get the latest news about hidden adventure gems, discounted launch
            trips and much more straight to your inbox
        </p>
        <div>
            @defer (on viewport; prefetch on idle) {
                <app-newsletter-form
                    [inputClasses]="[
                        'bg-white',
                        'placeholder-lightgrey',
                        'text-black',
                    ]">
                    Sign Up!
                </app-newsletter-form>
            } @placeholder {
                <div></div>
            }
        </div>
    </div>
</div>
